<div
    #mybets_filter
    id="mybets_filter"
    class="my-bets-settled-toolbar"
    [ngClass]="toggleResponsiveFilter ? 'open' : 'collapsed'"
    [class.filtred]="isFiltered">
    @if (showConstraints) {
        <div class="my-bets-settled-toolbar_constraints" [class.migrated]="showMigrationTabs">
            @for (constraint of filterConstraint.constraints; track constraint) {
                @if (!isMigrationConstraint(constraint)) {
                    <ms-my-bets-filter-constraint-button [constraint]="constraint" (remove)="onConstraintIsRemoved($event)" />
                }
            }
        </div>
    }
    <div class="my-bets-settled-toolbar_first-row">
        @if (showMigrationTabs) {
            <ms-my-bets-migration-tabs [isSettled]="isSettled" />
        }
        <div class="my-bets-toolbar_buttons" [class.my-bets-settled-download-button]="showDownloadIcon">
            @if (showFilterButton) {
                <div class="my-bets-toolbar_button filter-button" (click)="onFilterBtnClicked()">
                    <ng-container
                        *ngTemplateOutlet="
                            toolbarbutton;
                            context: {
                                size: isEpcotEnabled ? 'medium' : 'small',
                                iconClass: isEpcotEnabled ? 'theme-filter' : 'theme-preferences',
                                buttonLabel: sitecore.myBets_FilterView.OpenFilterButtonLabel,
                                isFilter: true,
                            }
                        ">
                    </ng-container>
                </div>
            }
            @if (hasValidExportIconType && betslipsCount > 0) {
                <div class="my-bets-toolbar_button print-button" (click)="onPrintBtnClicked()">
                    <ng-container
                        *ngTemplateOutlet="
                            toolbarbutton;
                            context: {
                                size: showDownloadIcon ? 16 : 12,
                                iconClass: getIconClass,
                                buttonLabel: printButtonTitle,
                                isFilter: false,
                            }
                        ">
                    </ng-container>
                </div>
            }
        </div>
    </div>
</div>

<ng-template #toolbarbutton let-size="size" let-iconClass="iconClass" let-buttonLabel="buttonLabel" let-isFilter="isFilter">
    <button
        ds-button
        msThemedButton
        variant="outline"
        kind="tertiary"
        [themeKind]="buttonThemeKind"
        [size]="size"
        [class.my-bets-toolbar_button-nonepcot]="!isEpcotEnabled">
        <span class="d-inline-flex">
            <vn-icon class="my-bets-toolbar_button-icon" [name]="iconClass" [size]="size"></vn-icon>
            <span class="my-bets-toolbar_button-label" [class.download-label]="!isFilter">{{ buttonLabel }}</span>
        </span>
    </button>
</ng-template>
